import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExtraCost, ExtraCostParameter, ExtraCostParametersValues } from 'src/app/shared/models/data/extraCostParametersValues.model';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';

@Component({
  selector: 'app-modal-add-extra-costs',
  templateUrl: './modal-add-extra-costs.component.html',
  styleUrls: ['./modal-add-extra-costs.component.scss']
})
export class ModalAddExtraCostsComponent implements OnInit {

  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() extraCostParameters!: ExtraCostParameter[];


  extraCostsOptionsList!: SelectOption[]; // List of extra cost options for the dropdown
  extraNewOptions!: SelectOption[]; // List of extra cost options to add


  @Output() onSave = new EventEmitter<number[]>();
  @Output() onCancel = new EventEmitter<void>();

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.extraCostsOptionsList = this.extraCostParameters.map(
      (ex) => {
        let sc = new SelectOption();
        sc.value = ex.extraCostId;
        sc.text = ex.extraCostName;
        sc.disabled = ex.isOrderExtraCost;
        return sc;
      }
    );
    this.extraNewOptions = new Array();
    this.addExtraCost();
  }

  onCancelClick() {
    this.onCancel.emit();
  }

  onSaveClick() {
    const newExtraCostIds = this.extraNewOptions.map(sc => sc.value);
    this.onSave.emit(newExtraCostIds);
  }

  addExtraCost() {
    this.extraNewOptions.push(new SelectOption());
  }

  removeExtraCost(index: number) {
    this.extraNewOptions.splice(index, 1);
  }

  onExtraCostChange(event: any, opt: SelectOption) {
    opt.value = event;
    // Find the index of the changed row
    const changedIndex = this.extraNewOptions.findIndex(o => o.value == opt.value);
    const lastIndex = this.extraNewOptions.length - 1;

    // Only if this is the *last* row, add a new blank row
    if (changedIndex === lastIndex && opt.value) {
      this.addExtraCost();
    }
  }

  getFilteredOptionsForRow(row: SelectOption): SelectOption[] {
    const usedValuesInOtherRows = this.extraNewOptions
      .filter(r => r !== row && r.value != null)
      .map(r => r.value);

    return this.extraCostsOptionsList.filter(opt => {
      const isUsedByOtherRow = usedValuesInOtherRows.includes(opt.value);
      const isRowValue = row.value === opt.value;
      return !isUsedByOtherRow || isRowValue;
    });
  }

}
